import {
  Component,
  ElementRef,
  Input,
} from '@angular/core';

@Component({
    selector: 'pr-loader',
    templateUrl: './pr-loader.component.html',
    styleUrls: ['./pr-loader.component.scss'],
    standalone: false
})
export class PrLoaderComponent {
  @Input() loading: boolean = false;
  @Input() text: string = undefined;
  @Input() type: string = '';
  constructor(public elRef: ElementRef) {}
}
